/* eslint-disable @typescript-eslint/no-non-null-assertion */

export const config = {
  // Legacy API config (kept for backwards compatibility)
  API_URL: process.env.REACT_APP_API_URL || '',
  API_CALCULATOR_ID: process.env.REACT_APP_API_CALCULATOR_ID || '',
  // Supabase config
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL || 'https://cthohsapgqtiqlzvnqqt.supabase.co',
  SUPABASE_ANON_KEY:
    process.env.REACT_APP_SUPABASE_ANON_KEY ||
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN0aG9oc2FwZ3F0aXFsenZucXF0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjUyODg4OTQsImV4cCI6MjA4MDg2NDg5NH0.i48kZsijFnE_SKSmlqIoSmor7E_iddQjzXmJDCy7GmA',
  SUPABASE_CALCULATOR_ID: process.env.REACT_APP_SUPABASE_CALCULATOR_ID || 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  // Other config
  SEA_ROUTES_API_KEY: process.env.REACT_APP_SEA_ROUTES_API_KEY || '',
  DICTIONARY_URL: process.env.REACT_APP_DICTIONARY_URL || '',
};
